module.exports = __webpack_public_path__ + "img/tireview-logo-bw.2b23dc18.png";